module.exports = __webpack_public_path__ + "static/media/icon-efficient.2c76fb80.jpg";